module.exports.CompositeDateAttributes = {
  CREATED_AT: "created_at",
  UPDATED_AT: "updated_at",
};

module.exports.CompositeUserTraceAttributes = {
  CREATED_BY: "created_by",
  UPDATED_BY: "updated_by",
};
